/**
 * @generated SignedSource<<8d57b74f2f508a9bdd492770ef4b9b56>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_seller$data = {
  readonly monthsSinceStartDate: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSidebarSellerInfoAndContact_seller" | "useSellerRating_seller">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_seller";
};
export type PdpRespSidebarSellerInfoAndContactLazy_seller$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_seller",
  "selections": [
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSidebarSellerInfoAndContact_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSellerRating_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "e3dafb0ccd5280849be413f5005c2a2f";

export default node;
